/**
 * Translate a status enum value using the i18n system.
 * Falls back to humanized version of the raw value.
 */
export function formatStatus(status: string, t: (key: string) => string): string {
  const key = `status.${status}`;
  const translated = t(key);
  // If t() returns the key itself (not found), humanize the raw value
  if (translated === key) {
    return status
      .replace(/_/g, ' ')
      .replace(/\b\w/g, c => c.toUpperCase());
  }
  return translated;
}
